import { memo } from 'react'
import PathChoiceFieldGroup from 'components/PathChoiceFieldGroup'
import { observer } from 'mobx-react'
import { PathFormFieldProps } from 'interfaces/PathFormComponents.interface'
import { Debtor } from 'containers/PersonalForm/PersonalForm.interface'

type Props = Omit<PathFormFieldProps, 'onChange'> & {
  debtor?: Debtor
  clue?: string
  onChange?: (selected: boolean) => void
}

export const CHOICES = [
  { label: 'Ja', value: true },
  { label: 'Nein', value: false }
]

const PathYesNo = observer(
  ({ path, labelPath, clue, error, onChange }: Props) => (
    <PathChoiceFieldGroup<boolean>
      path={path}
      labelPath={labelPath}
      choices={CHOICES}
      error={error}
      clue={clue}
      onChange={onChange}
    />
  )
)

export default memo(PathYesNo)
